import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { HashRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./Redux/Store/Store";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { installGlobalAxios } from "./Utility/secureChannel";
import { installAutofillBlocker } from "./Utility/disableAutofill";

// Seedhe axios.get/post wali calls bhi secure channel se jaayein
installGlobalAxios();

// Forms me browser ki saved phone/email/address suggestions band
installAutofillBlocker();

const queryClient = new QueryClient();

// ✅ MOVED: baseUrl / ImagebaseUrl ab "./config/baseUrl" me define hoti hain
// (circular-dependency fix). Yahan sirf re-export hai taaki jitni bhi purani
// files "../../.." (yaani index.js) se inhe import kar rahi hain, wo na tootein.
export { baseUrl, ImagebaseUrl } from "./Baseurl";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Provider store={store}>
          <App />
        </Provider>
      </HashRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals();